import { FormConfigBase } from './abstract/form-config-base.class';
import { RadioModel } from './radio.model';
import { RadioListInterface } from '../interfaces/radio-list.interface';

export class RadioListModel extends FormConfigBase {
  radioList: RadioModel[];

  constructor( obj: RadioListInterface ) {
    super( obj );

    this.radioList = obj && obj.radioList && obj.radioList.length > 0
      ? obj.radioList.map( radioOpt => new RadioModel( radioOpt ) )
      : [];
  }

}
